
// Add process polyfill for packages that expect Node.js environment
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: { NODE_ENV: import.meta.env.MODE } };
}

import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import './index.css';
import './styles/responsive-slides.css';
import { Toaster } from './components/ui/toaster';

// Mount the app with strict mode disabled to avoid double-rendering issues with Supabase auth
createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <App />
    <Toaster />
  </AuthProvider>
);
